import { HttpRequest } from './HttpRequest'

export const GetInspectionByUnitId = async (unitId: number) => {
    try {
        const response = await HttpRequest().get(`/inpection/unitid/${unitId}`)
        if (response.data.message === 'OK') {
            return response.data.responseData
        }
    } catch (error) {
        throw error
    }
}

export interface IGetInspectionByUnitId {
    unitId: number
    unitCode: string
    transferPlanType: string
    inspectionDateAfterTransfer: string
    pjDateAfterTransfer: string
    statusTransfer: string
    letterPlanforCR: string
    inspection1Id: number
    inspection1PlanPJDate: string
    inspection1FinishPJDate: string
    inspection1PlanCRDate: string
    inspection1PlanCRTime: string
    inspection1CusDate: string
    inspection1TypeId: number
    inspection1TypeText: string
    inspection2Id: number
    inspection2PlanPJDate: string
    inspection2FinishPJDate: string
    inspection2PlanCRDate: string
    inspection2PlanCRTime: string
    inspection2CusDate: string
    inspection2TypeId: number
    inspection2TypeText: string
    inspection3Id: number
    inspection3PlanPJDate: string
    inspection3FinishPJDate: string
    inspection3PlanCRDate: string
    inspection3PlanCRTime: string
    inspection3CusDate: string
    inspection3TypeId: number
    inspection3TypeText: string
    inspection4Id: number
    inspection4PlanPJDate: string
    inspection4FinishPJDate: string
    inspection4PlanCRDate: string
    inspection4PlanCRTime: string
    inspection4CusDate: string
    inspection4TypeId: number
    inspection4TypeText: string
    crNote: string
    pjNote: string
}